<template>
  <div>
    <h1 class="ma-2">
      พนักงาน
    </h1>
    <v-container>
      <search-bar
        ref="searchBar"
        icon-status-all="fas fa-users"
        icon-status-active="fas fa-user-check"
        icon-status-in-active="fas fa-user-times"
        action-text="เพิ่มพนักงานใหม่"
        action-icon="fas fa-user-plus"
        :action-persmission="userType === 'ADMIN'"
        :status="status"
        @onSearchActionButtonClick="openFormDialog"
        @onStatusChange="onStatusChange"
        @search="search"
      />
      <v-row>
        <v-col>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th
                    class="text-left"
                  >
                    ชื่อ-นามสกุล
                  </th>
                  <th class="text-left">
                    สถานะ
                  </th>
                  <th class="text-left">
                    เพศ
                  </th>
                  <th class="text-left">
                    สร้างเมื่อ
                  </th>
                  <th class="text-left">
                    ตัวเลือก
                  </th>
                </tr>
              </thead>
              <tbody v-if="items.length > 0">
                <tr
                  v-for="item in items"
                  :key="item._id"
                >
                  <td width="40%">
                    <v-avatar
                      v-if="item.image"
                      size="36"
                      class="mr-2"
                    >
                      <img
                        :src="item.image"
                        alt="employeeImage"
                      >
                    </v-avatar>
                    <v-avatar
                      v-else
                      size="36"
                      color="orange"
                      class="mr-2"
                    >
                      <v-icon size="12">
                        fas fa-user
                      </v-icon>
                    </v-avatar>
                    {{ item.firstName }} {{ item.lastName }}
                  </td>
                  <td>
                    <span :class="`${item.status === 'ACTIVE' ? 'green' : 'yellow'}--text`">
                      &#x25cf; {{ item.status === 'ACTIVE' ? 'เปิดใช้งาน' : 'ปิดใช้งาน' }}
                    </span>
                  </td>
                  <td width="10%">
                    {{ item.gender === 'MALE' ? 'ชาย' : 'หญิง' }}
                  </td>
                  <td width="15%">
                    {{ item.createdAt | HumanDate }}
                  </td>
                  <td width="20%">
                    <v-btn
                      depressed
                      icon
                      @click="getemployee(item._id)"
                    >
                      <v-icon small>
                        fas fa-edit
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.status === 'ACTIVE'"
                      depressed
                      icon
                      color="yellow"
                      @click="updateStatus(item._id, 'INACTIVE')"
                    >
                      <v-icon small>
                        fas fa-user-times
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.status === 'INACTIVE'"
                      depressed
                      icon
                      color="green"
                      @click="updateStatus(item._id, 'ACTIVE')"
                    >
                      <v-icon small>
                        fas fa-user-check
                      </v-icon>
                    </v-btn>
                    <v-btn
                      depressed
                      icon
                      @click="deleteEmployee(item._id)"
                    >
                      <v-icon small>
                        fas fa-trash
                      </v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td
                    colspan="6"
                    class="text-center"
                  >
                    <v-icon left>
                      far fa-dizzy
                    </v-icon>
                    ไม่พบข้อมูล
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
    <employee-form
      :form-dialog="formDialog"
      :form-data="formData"
      :loading="loading"
      :is-edit="Boolean(selectedEmployee)"
      @closeDialog="closeFormDialog"
      @submitForm="sendRequest"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import SearchBar from '@/components/SearchBar.vue';
import EmployeeForm from '@/components/EmployeeForm.vue';
import http from '@/http';
import { SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT } from '@/store/mutation_types';

export default {
  name: 'EmployeeListView',
  components: {
    SearchBar,
    EmployeeForm,
  },
  data() {
    return {
      status: '',
      formDialog: false,
      formData: {},
      items: [],
      selectedEmployee: '',
    };
  },
  computed: {
    ...mapGetters(['loading', 'userType']),
  },
  watch: {
    async status(value) {
      if (value) {
        this.$refs.searchBar.onSearch();
      }
    },
  },
  async mounted() {
    this.status = 'All';
    this.$refs.searchBar.onSearch();
  },
  methods: {
    ...mapActions([SET_ALERT, SET_ERROR, SET_ALERT_CONTEXT]),
    openFormDialog() {
      if (!this.selectedEmployee) {
        this.formData = {
          firstName: '',
          lastName: '',
          address: '',
          congenitalDisease: '',
          email: '',
          image: '',
          telephone: '',
          gender: '',
        };
      }
      this.formDialog = true;
    },
    closeFormDialog() {
      if (this.selectedEmployee) {
        this.selectedEmployee = '';
      }
      this.formDialog = false;
    },
    async getemployee(id) {
      this.selectedEmployee = id;
      const employee = await http.get(`/employees/${id}`);
      this.formData = { ...employee.data };
      this.openFormDialog();
    },
    async sendRequest(formData) {
      const data = new FormData();
      Object.keys(formData).forEach(key => data.append(key, formData[key]));
      if (this.selectedEmployee) {
        await http.put(`/employees/${this.selectedEmployee}`, data, { 'Content-Type': 'multipart/form-data' });
      } else {
        await http.post('/employees', data, { 'Content-Type': 'multipart/form-data' });
      }
      this.closeFormDialog();
      this.$refs.searchBar.onSearch();
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('บันทึกพนักงานแล้ว');
    },
    async updateStatus(id, status) {
      await http.put(`/employees/${id}`, { status });
      this.$refs.searchBar.onSearch();
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('อัพเดทสถานะพนักงานแล้ว');
    },
    async search(value) {
      const result = await http.get(`/employees?name=${value.text}&status=${value.status}`);
      this.items = [...result.data];
    },
    async deleteEmployee(id) {
      await http.delete(`/employees/${id}`);
      this.$refs.searchBar.onSearch();
      this.SET_ALERT(true);
      this.SET_ERROR(false);
      this.SET_ALERT_CONTEXT('ลบพนักงานแล้ว');
    },
    onStatusChange(value) {
      this.status = value;
    },
  },
};
</script>
